import { useAppSelector } from './use-app-selector';

const useGetCookieAccepted = () => {
  const getLocalStorage = localStorage.getItem('userCookiesConsent');
  const parsedLocalStorage = getLocalStorage ? JSON.parse(getLocalStorage) : null;
  const isCookiesAccepted = parsedLocalStorage ? parsedLocalStorage.acceptedCookies : false;
  const showCookieBanner = useAppSelector((state) => state.layout.showCookieBanner);
  const showCookieBannerFromLocalStorage: boolean = parsedLocalStorage ? parsedLocalStorage.showCookieBanner : true;

  return { showCookieBanner, showCookieBannerFromLocalStorage, isCookiesAccepted };
};

export default useGetCookieAccepted;
